export default "__VITE_ASSET__25d2581e__"